import ResourceSvc from '@/services/resource.svc.js';
import { Pagination as LPagination } from '@/components/index';
import { Table, TableColumn, Select, Option } from 'element-ui';

const resourceService = new ResourceSvc();

const matchesSearch = (member, query) => {
    const q = query.toLowerCase();
    return (member.fullName || '').toLowerCase().includes(q)
        || String(member.tiNumber || '').includes(q)
        || (member.email || '').toLowerCase().includes(q);
};

const parseMemberFromPreview = (data) => ({
    id: data.id,
    tiNumber: data.tiNumber,
    fullName: data.fullName || '',
    email: data.email || '',
    gender: data.gender || '',
    dateOfBirth: data.dateOfBirth || '',
    address: data.address || '',
    phone: data.phone || '',
    membershipType: data.membershipType || '',
    paymentStatus: data.paymentStatus || '',
    isAutoRenewalEnabled: data.isAutoRenewalEnabled || false
});

export default {
    name: 'AdminClubMembersSection',

    components: {
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Select.name]: Select,
        [Option.name]: Option,
        'l-pagination': LPagination
    },

    props: {
        clubMembers: {
            type: Array,
            required: true
        },
        clubMemberIds: {
            type: Array,
            required: true
        },
        clubId: {
            type: Number,
            required: true
        },
        year: {
            type: [Number, String],
            default: null
        }
    },

    data() {
        return {
            newMemberQuery: '',
            lookupLoading: false,
            lookupError: '',
            isExporting: false,
            searchQuery: '',
            pagination: {
                perPage: 25,
                currentPage: 1,
                perPageOptions: [10, 25, 50, 100],
                total: 0
            }
        };
    },

    computed: {
        membersCount() {
            return this.clubMembers ? this.clubMembers.length : 0;
        },

        filteredMembers() {
            if (!this.searchQuery) return this.clubMembers;
            return this.clubMembers.filter(m => matchesSearch(m, this.searchQuery));
        },

        pagedMembers() {
            const start = this.pagination.perPage * (this.pagination.currentPage - 1);
            const end = start + this.pagination.perPage;
            return this.filteredMembers.slice(start, end);
        }
    },

    watch: {
        filteredMembers(val) {
            this.pagination.total = val.length;
            this.pagination.currentPage = 1;
        },

        clubMembers() {
            this.pagination.total = this.filteredMembers.length;
        }
    },

    methods: {
        emitUpdatedLists(members, ids) {
            this.$emit('update:clubMembers', members);
            this.$emit('update:clubMemberIds', ids);
        },

        async lookupAndAdd() {
            const query = (this.newMemberQuery || '').trim();
            if (!query) {
                this.lookupError = 'Please enter a TI Number or email address';
                return;
            }

            this.lookupLoading = true;
            this.lookupError = '';

            try {
                const response = await resourceService.getMemberByLoginOrTiID(query);
                if (!response || !response.body || !response.body.isSuccess || !response.body.outputData) {
                    this.lookupError = 'User not found';
                    return;
                }

                const userId = response.body.outputData['Id'];
                const fullName = ((response.body.outputData['First Name'] || '') + ' ' + (response.body.outputData['Last Name'] || '')).trim();

                if (this.clubMemberIds.some(id => id === userId)) {
                    this.lookupError = fullName + ' is already a member of this club';
                    return;
                }

                const previewRes = await resourceService.getClubMemberPreview(userId, this.clubId);
                if (!previewRes || !previewRes.body || !previewRes.body.isSuccess || !previewRes.body.outputData) {
                    this.lookupError = 'Could not load member details';
                    return;
                }

                const member = parseMemberFromPreview(previewRes.body.outputData);

                this.emitUpdatedLists(
                    [...this.clubMembers, member],
                    [...this.clubMemberIds, member.id]
                );
                this.newMemberQuery = '';
            } catch (e) {
                this.lookupError = 'Error looking up user';
            } finally {
                this.lookupLoading = false;
            }
        },

        removeMember(pagedIndex) {
            const member = this.pagedMembers[pagedIndex];
            if (!member) return;

            const members = this.clubMembers.filter(m => m.id !== member.id);
            const ids = this.clubMemberIds.filter(id => id !== member.id);
            this.emitUpdatedLists(members, ids);
        },

        exportToExcel() {
            this.isExporting = true;
            const url = '/api/Admin/Club/ExportClubMembers?clubId=' + this.clubId + (this.year ? '&year=' + this.year : '');

            fetch(url, { credentials: 'same-origin' })
                .then(response => {
                    if (!response.ok) throw new Error('Export failed');
                    return response.blob();
                })
                .then(blob => {
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    link.download = 'ClubMembers.xlsx';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    URL.revokeObjectURL(link.href);
                })
                .catch(() => {
                    this.$emit('error', 'Failed to export to Excel');
                })
                .finally(() => {
                    this.isExporting = false;
                });
        }
    },

    mounted() {
        this.pagination.total = this.clubMembers.length;
    }
};



// WEBPACK FOOTER //
// ./src/components/admin/club/club-detail/sections/admin-club-members-section/admin-club-members-section.js